(() => {
  const main = qs('#js-main');
  const stickyHeader = qs('.js-header-sticky');
  const headerContainer = stickyHeader ? stickyHeader.parentElement.offsetTop : 0;
  const headerFixed = 'header--fixed';

  if(stickyHeader) {
    const bottomValue = stickyHeader.getBoundingClientRect().top + stickyHeader.clientHeight;
    stickyHeader.style.setProperty('--burger-menu-top', `${bottomValue}px`);
    document.body.style.setProperty('--header-height', `${bottomValue}px`);

    const headerSearch = document.querySelector('.js-header__search');

    window.addEventListener('scroll', () => {
      const top = document.documentElement.style.getPropertyValue('top');
      const topValue = top ? Number(top.replace('px', '').replace('-', '')) : 0;

      if(window.scrollY > headerContainer &&
        document.body.clientHeight > window.innerHeight) {
        stickyHeader.classList.add(headerFixed);
        main.style.marginTop = `${stickyHeader.getBoundingClientRect().height}px`;
        main.style.setProperty(`--timeline-menu-top`, `${stickyHeader.getBoundingClientRect().height}px`);
        stickyHeader.style.setProperty('--burger-menu-top', `${stickyHeader.getBoundingClientRect().height}px`);
        document.body.style.setProperty('--header-height', `${stickyHeader.getBoundingClientRect().height}px`);
        if (headerSearch && window.innerWidth <= 989) {
          headerSearch.classList.add('header__search--hidden');
        }
      } else if(topValue > headerContainer) {
        stickyHeader.style.top = 0;
      } else {
        stickyHeader.classList.remove(headerFixed);
        main.style.marginTop = '';
        main.style.setProperty(`--timeline-menu-top`, 0);
        stickyHeader.style.setProperty('--burger-menu-top', `${bottomValue}px`);
        document.body.style.setProperty('--header-height', `${bottomValue}px`);
        if (headerSearch && window.innerWidth <= 989) {
          headerSearch.classList.remove('header__search--hidden');
        }
      }
    })
  }

  new Selector({ id: '#language-selector', onChange: (e) => console.log(e) });
  new Selector({ id: '#country-selector', onChange: (e) => console.log(e) });
  new Selector({ id: '#country-selector-mobile', onChange: (e) => console.log(e) });
  new Selector({ id: '#country-selector-footer', onChange: (e) => console.log(e) });
  new Selector({ id: '#currency-selector', onChange: (e) => console.log(e) });
})();


// MOBILE MENU TOP OFFSET (announcement bar) **************************************************

/**
 * Keeps --mm-menu-top in sync with the bottom edge of the announcement bar.
 * When scrolled past the bar, falls back to 0.
 */
(() => {
  const bar = document.getElementById('shopify-section-annoucement-bar');
  const menu = document.querySelector('.mm-mobile-menu-wrapper');
  if (!menu) return;

  const update = () => {
    const h = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
    menu.style.setProperty('--mm-menu-top', `${h}px`);
    document.body.style.setProperty('--mm-bar-bottom', `${h}px`);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });

  if (bar) {
    new ResizeObserver(update).observe(bar);
  }
})();


// BACKGROUND FILTER *************************************************************************

const showBgFilter = () => document.querySelector('[data-filter]')?.classList.add('active');
const hideBgFilter = () => document.querySelector('[data-filter]')?.classList.remove('active');

/**
 * Add background filter on hover over mega menu links.
 */
const hoverBgFilter = () => {
  const header = document.querySelector('header.header');
  const searchContainer = document.querySelector('.mm-search-container-header');
  const megaMenuLinks = document.querySelectorAll('[data-megamenulink]');
  const menuLinks = document.querySelectorAll('[data-menulink]');
  const filter = document.querySelector('[data-filter]');
  const cart = document.querySelector('[data-cart-filter]');

  if (!header || !filter || !cart) return;

  const toggleFilter = (show) => filter.classList.toggle('active', show);

  megaMenuLinks.forEach((link) => link.addEventListener('mouseenter', () => toggleFilter(true)));
  menuLinks.forEach((link) => link.addEventListener('mouseenter', () => toggleFilter(false)));

  header.addEventListener('mouseleave', () => {
    const predictiveSearchDefault = document.getElementById('predictive-search-default');
    const predictiveSearch = document.getElementById('predictive-search');
    const isSearchOpen = (predictiveSearchDefault && predictiveSearchDefault.style.display === 'flex') ||
                         (predictiveSearch && predictiveSearch.style.display === 'block');

    if ((!searchContainer || !searchContainer.classList.contains('mm-open')) &&
        !cart.classList.contains('mm-dc-is-open') &&
        !isSearchOpen) {
      toggleFilter(false);
    }
  });
};


// SEARCH ************************************************************************************

/**
 * Show the search bar on product page (mobile).
 * Reveals the hidden search container and focuses the input to trigger predictive search.
 */
const mmShowSearchProduct = () => {
  const searchContainer = document.querySelector('.mm-search-container-header');
  if (!searchContainer) return;

  searchContainer.classList.remove('mm-none');
  searchContainer.classList.add('mm-flex');

  const searchInput = searchContainer.querySelector('input[type="search"]');
  if (searchInput) {
    setTimeout(() => searchInput.focus(), 300);
  }
};

/**
 * Close the search bar on product page (mobile).
 * Hides the search container and closes predictive search panels.
 */
const mmCloseSearchProduct = () => {
  const searchContainer = document.querySelector('.mm-search-container-header');
  if (!searchContainer) return;

  const predictiveSearchDefault = document.getElementById('predictive-search-default');
  const predictiveSearchResults = document.getElementById('predictive-search');

  if (predictiveSearchDefault) predictiveSearchDefault.style.display = 'none';
  if (predictiveSearchResults) predictiveSearchResults.style.display = 'none';

  const closeButton = searchContainer.querySelector('.mm-search-close');
  if (closeButton) closeButton.style.display = 'none';

  document.documentElement.classList.remove('stop-scrolling');

  const header = document.querySelector('header.header');
  if (header) header.classList.remove('mm-header-scroll');

  searchContainer.classList.remove('mm-flex');
  searchContainer.classList.add('mm-none');

  const searchInput = searchContainer.querySelector('input[type="search"]');
  if (searchInput) {
    searchInput.value = '';
    searchInput.setAttribute('aria-expanded', 'false');
    searchInput.blur();
  }
};

/**
 * Open the search bar (desktop / standard).
 */
const mmShowSearch = () => {
  const searchContainer = document.querySelector('.mm-search-container-header');
  const searchInput = document.getElementById('Search');

  if (!searchContainer || !searchInput) return;

  document.documentElement.classList.add('stop-scrolling');
  searchContainer.classList.add('mm-open');
  showBgFilter();

  setTimeout(() => searchInput.focus(), 300);

  document.getElementById('predictive-search')?.addEventListener('touchstart', () => {
    setTimeout(() => searchInput.blur(), 500);
  });
};

/**
 * Close the search bar (desktop / standard).
 */
const mmHideSearch = (keepFilterActive = false) => {
  const searchContainer = document.querySelector('.mm-search-container-header');
  const searchInput = document.getElementById('Search');

  if (!searchContainer || !searchInput) return;

  document.documentElement.classList.remove('stop-scrolling');
  searchContainer.classList.remove('mm-open');
  if (!keepFilterActive) hideBgFilter();

  const header = document.querySelector('.mm-section-header');
  if (header) header.classList.remove('mm-header-scroll');

  searchInput.value = '';
  searchInput.dispatchEvent(new Event('input'));
};

/**
 * Global close handler called from HTML onclick attributes (main-search.liquid, predictive-search-default.liquid).
 * Delegates to the PredictiveSearch custom element's closeSearch() if available,
 * otherwise falls back to mmHideSearch().
 */
const mmCloseSearch = () => {
  const predictiveSearchEl = document.querySelector('predictive-search');
  if (predictiveSearchEl && typeof predictiveSearchEl.closeSearch === 'function') {
    predictiveSearchEl.closeSearch();
  } else {
    mmHideSearch();
  }
};


// SEARCH ARTICLES SPLIDE ********************************************************************

/**
 * Init Splide on the search articles slider.
 * Called once when the predictive-search-default panel is first displayed.
 */
const mmInitSearchArticlesSplide = () => {
  const el = document.querySelector('.mm-search-articles-splide');
  if (!el || el.classList.contains('mm-is-initialized')) return;
  try {
    new Splide(el).mount();
    el.classList.add('mm-is-initialized');
  } catch (e) {
    console.warn('Search articles Splide init error:', e);
  }
};

/**
 * Init Splide on the search products slider (mobile only).
 * Called once when the predictive-search-default panel is first displayed.
 */
const mmInitSearchProductsSplide = () => {
  if (window.innerWidth > 1024) return;
  const el = document.querySelector('.mm-search-products-splide');
  if (!el || el.classList.contains('mm-is-initialized')) return;
  try {
    new Splide(el, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      gap: '12px',
      arrows: false,
      pagination: false,
      padding: { right: '40px' },
    }).mount();
    el.classList.add('mm-is-initialized');
  } catch (e) {
    console.warn('Search products Splide init error:', e);
  }
};

// Init splides when the predictive-search-default panel becomes visible
const predictiveDefaultPanel = document.getElementById('predictive-search-default');
if (predictiveDefaultPanel) {
  new MutationObserver(() => {
    if (predictiveDefaultPanel.style.display === 'flex') {
      mmInitSearchArticlesSplide();
      mmInitSearchProductsSplide();
    }
  }).observe(predictiveDefaultPanel, { attributes: true, attributeFilter: ['style'] });
}

// Init products Splide in results panel (#predictive-search) each time content is injected
const predictiveResultsPanel = document.getElementById('predictive-search');
if (predictiveResultsPanel) {
  new MutationObserver(() => {
    if (predictiveResultsPanel.style.display !== 'block') return;
    if (window.innerWidth > 1024) return;
    const el = predictiveResultsPanel.querySelector('.mm-results-products-splide');
    if (!el) return;
    try {
      new Splide(el, {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '12px',
        arrows: false,
        pagination: false,
        padding: { right: '40px' },
      }).mount();
    } catch (e) {
      console.warn('Results products Splide init error:', e);
    }
  }).observe(predictiveResultsPanel, { childList: true });
}

// MOBILE MENU ********************************************************************************

/**
 * Open the mobile menu drawer.
 */
let _mmScrollY = 0;

const mmMobileMenu = () => {
  const wrapper = document.querySelector('[data-menu-mobile]');
  if (!wrapper) return;
  _mmScrollY = window.scrollY;
  document.body.style.top = `-${_mmScrollY}px`;
  wrapper.classList.add('mm-open');
  document.body.classList.add('mm-no-scroll');
};

/**
 * Close the mobile menu drawer and reset all sub-panels.
 */
const mmCloseMobileMenu = () => {
  const wrapper = document.querySelector('[data-menu-mobile]');
  if (!wrapper) return;
  wrapper.classList.remove('mm-open');
  document.body.classList.remove('mm-no-scroll');
  document.body.style.top = '';
  window.scrollTo(0, _mmScrollY);
  // Reset all open sub-panels
  wrapper.querySelectorAll('[data-mobile-panel].mm-active').forEach((panel) => {
    panel.classList.remove('mm-active');
    panel.setAttribute('aria-hidden', 'true');
  });
  wrapper.querySelectorAll('[data-mobile-open][aria-expanded="true"]').forEach((btn) => {
    btn.setAttribute('aria-expanded', 'false');
  });
};

/**
 * Ouvre le picker de langue mobile.
 */
const mmOpenLangPicker = () => {
  const picker = document.getElementById('mm-lang-picker');
  if (!picker) return;
  picker.classList.add('mm-open');
  picker.setAttribute('aria-hidden', 'false');
};

/**
 * Ferme le picker de langue mobile.
 */
const mmCloseLangPicker = () => {
  const picker = document.getElementById('mm-lang-picker');
  if (!picker) return;
  picker.classList.remove('mm-open');
  picker.setAttribute('aria-hidden', 'true');
};

// Fermer le menu en cliquant sur l'overlay
document.addEventListener('click', (e) => {
  const wrapper = document.querySelector('[data-menu-mobile]');
  if (!wrapper || !wrapper.classList.contains('mm-open')) return;
  // Ignorer le clic sur le burger (il ouvre/ferme lui-même via mmMobileMenu)
  const burger = document.querySelector('[data-header-burger]');
  if (burger && burger.contains(e.target)) return;
  if (!wrapper.contains(e.target)) mmCloseMobileMenu();
});

// Sub-panel slide-in logic
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('[data-menu-mobile]');
  if (!wrapper) return;

  // Open sub-panel
  wrapper.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-mobile-open]');
    if (!trigger) return;
    const panelId = trigger.dataset.mobileOpen;
    const panel = wrapper.querySelector(`[data-mobile-panel="${panelId}"]`);
    if (!panel) return;
    panel.classList.add('mm-active');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
  });

  // Close sub-panel (back button)
  wrapper.addEventListener('click', (e) => {
    const backBtn = e.target.closest('[data-mobile-close]');
    if (!backBtn) return;
    const panelId = backBtn.dataset.mobileClose;
    const panel = wrapper.querySelector(`[data-mobile-panel="${panelId}"]`);
    const trigger = wrapper.querySelector(`[data-mobile-open="${panelId}"]`);
    if (panel) {
      panel.classList.remove('mm-active');
      panel.setAttribute('aria-hidden', 'true');
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  });

  // Init recipe Splide when a sub-panel becomes active
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.type !== 'attributes' || m.attributeName !== 'class') return;
      const panel = m.target;
      if (!panel.classList.contains('mm-active')) return;
      panel.querySelectorAll('.mm-mobile-s3-recipe-splide:not(.is-initialized)').forEach((el) => {
        try {
          new Splide(el, {
            type: 'slide',
            perPage: 1,
            gap: '12px',
            arrows: false,
            pagination: false,
            padding: { left: '16px', right: '56px' },
          }).mount();
        } catch (err) {
          console.warn('Recipe Splide init error:', err);
        }
      });
    });
  }).observe(wrapper, { attributes: true, attributeFilter: ['class'], subtree: true });
});

// SEARCH BUTTON (mobile, non-homepage) *******************************************************

/**
 * Show the search bar and open predictive search when the mobile search icon is clicked.
 * On non-homepage the .header__search is hidden by CSS; this reveals it and focuses the input.
 */
document.addEventListener('DOMContentLoaded', () => {
  const searchButton = document.querySelector('.js-header__search-button');
  if (!searchButton) return;

  searchButton.addEventListener('click', (e) => {
    e.preventDefault();
    const headerSearch = document.querySelector('.js-header__search');
    const searchInput = document.getElementById('Search');
    const header = document.querySelector('.mm-section-header');

    if (!headerSearch || !searchInput) return;

    // 1. Remove hidden state (visibility/opacity)
    headerSearch.classList.remove('header__search--hidden');
    // 2. Force display — overrides "display: none !important" from mobile CSS
    headerSearch.style.display = 'flex';
    // 3. Add mm-header-scroll immediately so the CSS mobile transformation is ready
    if (header) header.classList.add('mm-header-scroll');
    // 4. Focus synchronously (required on iOS — setTimeout breaks the gesture context)
    searchInput.focus();
  });
});
